import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavigation = (path: string) => {
    window.REACT_APP_NAVIGATE(path);
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-lg' : 'bg-white'}`}>
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div 
          className="flex items-center gap-3 cursor-pointer"
          onClick={() => handleNavigation('/')}
        >
          <img 
            src="https://static.readdy.ai/image/e5292f43a8fca29a2b9f75d3d42cfb52/a79cb0bec034472cb10b80478a2788a7.png" 
            alt="iCarga Logo" 
            className="h-16 w-16 rounded-full object-cover"
          />
          <span className="text-3xl font-bold text-gray-900">
            iCarGA
          </span>
        </div>
        
        <div className="hidden md:flex items-center space-x-8">
          <a 
            onClick={() => handleNavigation('/inventory')}
            className="text-sm font-light text-gray-700 hover:text-[#2563EB] transition-colors cursor-pointer"
          >
            Inventory
          </a>
          <a 
            onClick={() => handleNavigation('/')}
            className="text-sm font-light text-gray-700 hover:text-[#2563EB] transition-colors cursor-pointer"
          >
            Financing
          </a>
          <a 
            onClick={() => handleNavigation('/sell-trade')}
            className="text-sm font-light text-[#2563EB] transition-colors cursor-pointer"
          >
            Sell/Trade
          </a>
          <a 
            onClick={() => handleNavigation('/')}
            className="text-sm font-light text-gray-700 hover:text-[#2563EB] transition-colors cursor-pointer"
          >
            Reviews
          </a>
        </div>

        <button 
          onClick={() => handleNavigation('/')}
          className="px-6 py-2.5 bg-[#2563EB] text-white rounded-full text-sm font-medium hover:bg-[#1d4ed8] transition-colors whitespace-nowrap cursor-pointer"
        >
          Get Pre-Approved
        </button>
      </div>
    </nav>
  );
}
